// import "./past_result.css";
import { useState, useEffect } from "react";
import { Drop_down_selection } from "./Drop_down_selection";

export default function Past_results() {
  const [teams, setTeams] = useState([]);
  // pagination

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(teams.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTeams = teams.slice(indexOfFirstItem, indexOfLastItem);

  const goToPage = (pageNumber) => setCurrentPage(pageNumber);
  console.log("current page", currentPage);
  const nextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  // end :: pagination

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [teamDetails, setTeamDetails] = useState({});
  const [original, setOriginal] = useState({});

  console.log("team details log", teamDetails);
  const [expandedMatch, setExpandedMatch] = useState({});

  const [matchApiData, setMatchApiData] = useState({});
  console.log("matchApi", matchApiData);
  const [loadingKey, setLoadingKey] = useState(null);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  const toggleExpandMatch = (matchKey) => {
    setExpandedMatch((prev) => {
      const willExpand = !prev[matchKey];

      // 👉 only fetch when expanding AND data not fetched yet
      if (willExpand && !matchApiData[matchKey]) {
        fetchMatchData(matchKey);
      }

      return {
        ...prev,
        [matchKey]: willExpand,
      };
    });
  };

  // fetching the team specific data
  const fetchMatchData = async (matchKey) => {
    try {
      setLoadingKey(matchKey);

      const res = await fetch(
        `${API_URL}/match-details/${matchKey}`
      );
      const data = await res.json();
      console.log("extra details ", data);

      setMatchApiData((prev) => ({
        ...prev,
        [matchKey]: data,
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingKey(null);
    }
  };

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await fetch(
          `${API_URL}/pastresults/tableNames`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Team Names", data);
        setTeams(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  if (loading) return <p>Loading teams...</p>;
  if (error) return <p>Error: {error}</p>;

  const toggleExpand = async (teamKey) => {
    // collapse if already expanded
    if (expandedIndex === teamKey) {
      setExpandedIndex(null);
      return;
    }

    // fetch details if not already fetched
    if (!teamDetails[teamKey]) {
      try {
        const res = await fetch(
          `${API_URL}/teamdetails/${teamKey}`
        );
        const data = await res.json();
        setTeamDetails((prev) => ({ ...prev, [teamKey]: data.data || [] }));
        console.log("status", teamDetails);
        setOriginal((prev) => ({ ...prev, [teamKey]: data.data || [] }));
      } catch (err) {
        console.error("Error fetching team details:", err);
      }
    }

    setExpandedIndex(teamKey);
  };

  return (
    <>
      {/* main container */}
      <div className="alg1_card">
        {/* header section */}
        <h1 className="title_header">TEAM RESULTS</h1>
        <div className="week_label">Week {currentPage}</div>
        <div className="results_section">
          {/* team container */}
          <div className="team_cards_container">
            {currentTeams.map((team) => (
              <div className="team_card" key={team.tableName}>
                <div
                  className="team_header"
                  onClick={() => toggleExpand(team.tableName)}
                >
                  <span>
                    {team.tableName} || {team.correct_count}/ {team.total_count}
                  </span>
                  <span
                    className={`arrow ${
                      expandedIndex === team.tableName ? "open" : ""
                    }`}
                  >
                    &#9654;
                  </span>
                </div>

                {expandedIndex === team.tableName && (
                  <div className="team_details">
                    {teamDetails[team.tableName] ? (
                      <>
                        <div>
                          <Drop_down_selection
                            setTeamDetails={setTeamDetails}
                            teamKey={team.tableName}
                            original={original[team.tableName]}
                          />
                        </div>
                        <ul className="team_details_list">
                          {teamDetails[team.tableName].map((match) => {
                            const matchKey = match.Team_code; // use as unique key for expansion
                            return (
                              <li key={match.Team_code} className="match_item">
                                <div
                                  className="match_header"
                                  onClick={() => toggleExpandMatch(matchKey)} // define this in your component
                                >
                                  <span>
                                    {/* win/lose marker  */}
                                    <span
                                      className={
                                        match.Prediction === "UNDER 3.5"
                                          ? match.Home_score +
                                              match.Away_score <=
                                            3
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" || match.Prediction === "GG"
                                          ? match.Home_score > 0 &&
                                            match.Away_score > 0
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" ||
                                            match.Prediction === "UNDER 2.5"
                                          ? match.Home_score +
                                              match.Away_score <=
                                            2
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" ||
                                            match.Prediction === "OVER 2.5&GG"
                                          ? match.Home_score > 0 &&
                                            match.Away_score > 0 &&
                                            match.Home_score +
                                              match.Away_score >=
                                              3
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" ||
                                            match.Prediction === "OVER 2.5"
                                          ? match.Home_score +
                                              match.Away_score >=
                                            3
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" ||
                                            match.Prediction === "Home Win"
                                          ? match.Home_score > match.Away_score
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" ||
                                            match.Prediction === "OVER 3.5"
                                          ? match.Home_score +
                                              match.Away_score >=
                                            3
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : "" ||
                                            match.Prediction === "Away Win"
                                          ? match.Away_score > match.Home_score
                                            ? "correct_prediction"
                                            : "wrong_prediction"
                                          : ""
                                      }
                                    ></span>
                                    &nbsp; | &nbsp;
                                    {match.Home_Team} - {match.Away_Team}
                                    &nbsp; | {match.League}
                                    &nbsp; | {match.Schedule}
                                    &nbsp; | Pred : {match.Prediction}
                                    &nbsp; | Score : {match.Home_score} -{" "}
                                    {match.Away_score}
                                  </span>
                                  <span
                                    className={`arrow ${
                                      expandedMatch[matchKey] ? "open" : ""
                                    }`}
                                  >
                                    &#9654;
                                  </span>
                                </div>

                                {expandedMatch[matchKey] &&
                                  matchApiData[matchKey] && (
                                    <>
                                      {/* // loading ui */}
                                      <span>
                                        {loadingKey === matchKey && (
                                          <p>Loading extra data...</p>
                                        )}
                                      </span>

                                      {/* // main section */}
                                      <div className="main_section_space">
                                        {/* General Section */}
                                        <div className="general">
                                          <div className="general_card">
                                            <p>GENERAL CALC</p>
                                            <div className="general_card_content">
                                              <div className="sub_card">
                                                <p>Expected Goals</p>
                                                <span>
                                                  {
                                                    matchApiData[matchKey]
                                                      ?.general_H_exp_g
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {
                                                    matchApiData[matchKey]
                                                      .general_A_exp_g
                                                  }
                                                </span>
                                              </div>
                                              <div className="sub_card">
                                                <p>Correct_Score</p>
                                                <span>
                                                  {
                                                    matchApiData[matchKey]
                                                      .general_CS_1
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .general_CS_2
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="general_card">
                                            <p>ODDS</p>
                                            <div className="general_card_content">
                                              <div className="sub_card">
                                                <p>Expected Goals</p>
                                                <span>
                                                  {
                                                    matchApiData[matchKey]
                                                      .odds_H_exp_g
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .odds_A_exp_g
                                                  }
                                                </span>
                                              </div>
                                              <div className="sub_card">
                                                <p>Correct_Score</p>
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .odds_CS_1
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .odds_CS_2
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          {/*  #---- SECTION_NAME :: DECAY --> CARD ------- */}
                                          <div className="general_card">
                                            <p>DECAY</p>
                                            <div className="general_card_content">
                                              <div className="sub_card">
                                                <p>Expected Goals</p>
                                                <span>
                                                  {
                                                    matchApiData[matchKey]
                                                      .decay_H_exp_g
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .decay_A_exp_g
                                                  }
                                                </span>
                                              </div>
                                              <div className="sub_card">
                                                <p>Correct_Score</p>
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .decay_CS_1
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .decay_CS_2
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          {/*  #---- SECTION_NAME :: FORM --> CARD ------- */}
                                          <div className="general_card">
                                            <p>FORM</p>
                                            <div className="general_card_content">
                                              <div className="sub_card">
                                                <p>Expected Goals</p>
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .form_H_exp_g
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .form_A_exp_g
                                                  }
                                                </span>
                                              </div>
                                              <div className="sub_card">
                                                <p>Correct_Score</p>
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .form_CS_1
                                                  }
                                                </span>{" "}
                                                -{" "}
                                                <span>
                                                  {" "}
                                                  {
                                                    matchApiData[matchKey]
                                                      .form_CS_2
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Goals Section */}
                                        <div className="goals_section">
                                          <div className="goal_card">
                                            <p>Goals_mean</p>
                                            <span>
                                              {matchApiData[matchKey].H_mean}
                                            </span>{" "}
                                            -{" "}
                                            <span>
                                              {" "}
                                              {matchApiData[matchKey].A_mean}
                                            </span>
                                          </div>
                                          <div className="goal_card">
                                            <p>Cv_mean</p>
                                            <span>
                                              {matchApiData[matchKey].H_cv}
                                            </span>{" "}
                                            -{" "}
                                            <span>
                                              {matchApiData[matchKey].A_cv}
                                            </span>
                                          </div>
                                          <div className="goal_card">
                                            <p>H-2-H</p>
                                            <span>
                                              {
                                                matchApiData[matchKey]
                                                  .Home_score
                                              }{" "}
                                              -{" "}
                                              {
                                                matchApiData[matchKey]
                                                  .Away_score
                                              }
                                            </span>
                                          </div>
                                          <div className="goal_card">
                                            <p>pred_3</p>
                                            <span>
                                              {matchApiData[matchKey]
                                                ?.Prediction_3 || "null"}{" "}
                                              -
                                              {matchApiData[matchKey]
                                                ?.category || "null"}
                                            </span>
                                          </div>
                                          <div className="goal_card">
                                            <p>Total_pred</p>
                                            <span>
                                              {matchApiData[matchKey]?.H_mean +
                                                matchApiData[matchKey]?.A_mean}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {/* end :: main section */}
                                    </>
                                  )}
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    ) : (
                      <p>Loading details for {team}...</p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* pagiation  */}

        {/* Pagination Controls */}

        <div className="pagination-container">
          <button onClick={prevPage} disabled={currentPage === 1}>
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
            <button
              key={num}
              onClick={() => goToPage(num)}
              className={currentPage === num ? "active" : ""}
            >
              {num}
            </button>
          ))}

          <button onClick={nextPage} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>

        <div className="page-info">
          Page {currentPage} of {totalPages}
        </div>

        {/* end :: pagination */}
      </div>

      {/* main container End */}
    </>
  );
}
